import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { animationFrame } from 'rxjs/scheduler/animationFrame';
import { ISubscription } from 'rxjs/Subscription';

import 'rxjs/add/observable/interval';
import 'rxjs/add/operator/takeWhile';
import 'rxjs/add/operator/timeInterval';

@Injectable()
export class UpdateService {
  public tick = 0;
  public running = true;
  public loop$ = Observable
    .interval(0, animationFrame)
    .takeWhile(() => this.running)
    .timeInterval();
  public start: number = performance.now();
  public time: number = this.start;

  private loopSubscription: ISubscription;
  constructor() {
    this.loopSubscription = this.loop$.subscribe(({ value, interval }) => {
      this.tick = value;
      this.time = performance.now();
      if (this.tick % 1000 === 0) {
        console.log('tick! (' + interval + 'ms) ' + this.tick);
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/HeinousTugboat/Projects/survivalism/src/app/core/update.service.ts